$.validator.addMethod(
    "regex",
    function (value, element, regexp) {
        var re = new RegExp(regexp);
        return this.optional(element) || re.test(value);
    },
    "Поле заполнено не верно"
);

class InteractiveForm {
    constructor (el, opts = {}) {
        this.$form = $(el);

        let $form = this.$form;

        if ($form.data("action")) {
            $form.prop("action", $form.data("action"));
        }

        $form.find('[name="phone"]').inputmask({
            mask: "+7 999 999-99-99",
            showMaskOnHover: false
        });

        $form.find('[name="captcha"]').inputmask({
            mask: "99999",
            showMaskOnHover: false
        });

        let validatorOpts = {
            rules: {
                phone: {
                    required: true,
                    regex: /\+7\s\d\d\d\s\d\d\d\-\d\d\-\d\d/
                },

                captcha: {
                    required: true,
                    regex: /\d\d\d\d\d/
                }
            },
            errorElement: "em",
            onfocusout: (el /*, event*/) => {
                $(el).valid();
            },

            focusCleanup: false,
            submitHandler: opts.submitHandler || this.standartFormHandler, //(form)=>{}
            errorPlacement: ($errorLabel, $el) => {
                // if ($el.attr("name") === "agree") { return true; } else {}
                $errorLabel.addClass("form_hint form_hint-error");
                $el.before($errorLabel);
                return true;
            }
        };

        if (opts.validatorParams) {
            $.extend(true, validatorOpts, opts.validatorParams);
        }

        if (opts.successBlockMod) {
            $.extend(true, opts, { successBlockMod: "default" });
        }

        this.opts = opts;
        this.validator = $form.validate(validatorOpts);
    }

    standartFormHandler (form) {
        let $form = $(form);

        window.pagePreloader.show();

        let dataToSend = $.extend(true, $form.serializeObject(), {
            Submit: 1,
            url: window.location.href
        });

        $.ajax({
            url: form.action,
            type: form.method,
            data: dataToSend
        })
            .done(response => {
                let errorCode = parseInt(response.code);
                if (errorCode === 0) {
                    let successText =`
                        <div class="form_success">
                            <div class="form_successTxt">${ response.success }</div>
                        </div>
                    `;
                    window.requestAnimationFrame(() => {
                        $form.parent().hide().after(successText);
                    });
                } else {
                    alert("Не удалось отправить форму! Попробуйте позже или обратитесть по телефону...");
                }
            })
            .always((/*response*/) => {
                window.pagePreloader.hide();
            });
    }

    destroy () {
        this.validator.destroy();
        this.$form.find("input").inputmask("remove");
    }
}

class Preloader {
	constructor(selector) {
		let $el = $(selector);

		if (!$el.length) {
			console.error("Preloader class constructor cant't find target element!");
			return;
		}

		$el.get(0).onclick = event => {
			event.preventDefault();
			event.stopPropagation();
			return false;
		};

		this.$el = $el;
		this.isLocked = false;
	}

	show(cb) {
		if (this.isLocked) return false;
		this.$el.fadeIn(cb);
	}

	hide(cb) {
		if (this.isLocked) return false;
		this.$el.fadeOut(cb);
	}
}

const elHTML = document.documentElement;
const mainBlock = document.querySelector('main');
const footerBlock = [].slice.call(document.querySelectorAll('.Footer'));
const header = document.querySelector('.Header');
const burger = document.querySelector('.Header_burger');
const textBurger = document.querySelector('.Header_burgerText');
const textBurgerTrue = textBurger.innerHTML;
const menuMob = document.querySelector('.MenuMobile');

const preloader = document.getElementById('pagePreloader');
window.pagePreloader = new Preloader(preloader);
window.pagePreloader.hide();

burger.onclick = () => {
    burger.classList.toggle('Header_burger-close');
    header.classList.toggle('Header-darkText');
    menuMob.classList.toggle('MenuMobile-open');
    document.documentElement.classList.toggle('disabled');

    if (textBurgerTrue === textBurger.innerHTML) {
        textBurger.innerHTML = 'Закрыть';
    } else {
        textBurger.innerHTML = textBurgerTrue;
    }
};

if (window.location.pathname === '/') {
    if (elHTML.clientWidth >= 1024) {
        document.body.classList.add('disabled');
    }
}

if (window.location.pathname !== '/') {
    localStorage.setItem('fullPageActiveSlide', '0');
}

window.addEventListener('resize', () => {
    if (window.location.pathname === '/') {
        if (elHTML.clientWidth >= 1024) {
            document.body.classList.add('disabled');
        } else {
            document.body.classList.remove('disabled');
        }
    }
});

document.addEventListener("DOMContentLoaded", () => {
    if (window.location.pathname === '/') {
        mainBlock.style.height = '100%';
        mainBlock.style.paddingTop = `0`;
        mainBlock.classList.add('not-flex');
        // header.classList.remove('Header-white');
    }
});

[].forEach.call(document.querySelectorAll('.form'), form => {
    new InteractiveForm(form);
});

function parseQueryString (string) {
    if (string === "" || string == null) return {};
    if (string.charAt(0) === "?") string = string.slice(1);
    var entries = string.split("&"),
        data0 = {},
        counters = {};
    for (var i = 0; i < entries.length; i++){
        var entry = entries[i].split("=");
        var key5 = decodeURIComponent(entry[0]);
        var value = entry.length === 2 ? decodeURIComponent(entry[1]) : "";
        if (value === "true") value = true;
        else if (value === "false") value = false;
        var levels = key5.split(/\]\[?|\[/);
        var cursor = data0;
        if (key5.indexOf("[") > -1) levels.pop();
        for (var j = 0; j < levels.length; j++){
            var level = levels[j],
                nextLevel = levels[j + 1];
            var isNumber = nextLevel == "" || !isNaN(parseInt(nextLevel, 10));
            var isValue = j === levels.length - 1;
            if (level === "") {
                key5 = levels.slice(0, j).join();
                if (counters[key5] == null) counters[key5] = 0;
                level = counters[key5]++;
            }
            if (cursor[level] == null) {
                cursor[level] = isValue ? value : isNumber ? [] : {};
            }
            cursor = cursor[level];
        }
    }
    return data0;
}

if (header && window.location.pathname === '/') eventsScroll();

function eventsScroll () {
    checkScroll();

    window.addEventListener('resize', () => {
        checkScroll();
    });
    window.addEventListener('scroll', () => {
        checkScroll();
    });

    function checkScroll () {
        const scroll = window.pageYOffset;

        if (window.innerWidth < 1024) {
            if (scroll < 50) {
                header.classList.remove('Header-white-m');
            } else {
                header.classList.add('Header-white-m');
            }
        }
    }
}

$(document).ready(() => {
    $('[data-custom-select]').each(function () {
        var $this = $(this),
            numberOfOptions = $(this).children('option').length;

        $this.addClass('select-hidden');
        $this.wrap('<div class="select"></div>');
        $this.after('<div class="select-styled"></div>');

        var $styledSelect = $this.next('div.select-styled');
        $styledSelect.text($this.children('option').eq(0).text());

        var $list = $('<ul />', {
            'class': 'select-options'
        }).insertAfter($styledSelect);

        for (var i = 0; i < numberOfOptions; i++){
            $('<li />', {
                text: $this.children('option').eq(i).text(),
                rel: $this.children('option').eq(i).val()
            }).appendTo($list);
        }

        var $listItems = $list.children('li');

        $styledSelect.click(function (e) {
            e.stopPropagation();
            $('div.select-styled.active').not(this).each(function () {
                $(this).removeClass('active').next('ul.select-options').hide();
            });
            $(this).toggleClass('active').next('ul.select-options').toggle();
        });

        $listItems.click(function (e) {
            e.stopPropagation();
            $styledSelect.text($(this).text()).removeClass('active');
            $this.val($(this).attr('rel'));
            $list.hide();
            //console.log($this.val());
        });

        $(document).click(function () {
            $styledSelect.removeClass('active');
            $list.hide();
        });

    });
    
});

$(document).ready(() => {
    let $consultForm = $('.popupConsult__form');
    $consultForm.each(function (i, consultForm) {
        console.log($(consultForm), 'cform')
        new InteractiveForm(consultForm);

        $(consultForm).on('change', 'input', function () {
            let validateForm = $(consultForm).validate();
            let formIsValid = validateForm.form();

            if (formIsValid) {
                $(consultForm).find('button[type="submit"]').addClass('valid');
            } else {
                $(consultForm).find('button[type="submit"]').removeClass('valid');
            }
        });
    })
})

$('[data-head]').on('click', function () {
    let subtitle = $(this).data('head');
    let comment = $(this).data('comment');
    let popupConsult = $('#popup-consult');
    let inputComment = popupConsult.find('input[name="comment"]');
    popupConsult.find('.popupConsult__subtitle').html(subtitle);
    inputComment.val(comment);
});

function InitUpBtn (btn) {
    btn.addEventListener('click', () => {
        window.scroll({
            top: 0,
            behavior: 'smooth',
        });
        if (fullPageIndex) {
            fullPageIndex.slideTo(0, 300);
        }
    });
}

[].forEach.call(document.querySelectorAll('.js-up-btn'), btn => {
    InitUpBtn(btn);
});

function InitInput (input) {
    input.addEventListener('blur', () => {
        input.classList.toggle('not-empty', input.value);
    });
}

[].forEach.call(document.querySelectorAll('.js-input'), input => {
    InitInput(input);
});

$(document).ready(() => {
    // console.log($('.OnCall'), 'oncall');
    // console.log($('.CallMe'), 'oncall');

    $('.OnCall').on('click', function (e) {
        if ($(e.target).hasClass('OnCall__btn-toForm')) {
            // console.log('dffdfd')
            e.preventDefault();
            $(e.currentTarget).hide();
            $(e.currentTarget).next().show();
        }
    });

    $('.callMe').on('click', function (e) {

        if ($(e.target).hasClass('popupConsult__toBack')) {
            e.preventDefault();
            $(e.currentTarget).hide();
            $(e.currentTarget).prev().show();
        }
    });
})

$('[data-fancybox="popup-call"]').fancybox({
    toolbar  : false,
    hash : false,
    touch: false,
});

$(function(){
    $('#svg-sprite').load('/ajax/svg-sprites.php', function(e) {
    });
});

$( function() {
    let $flatView = $('[data-flat-view]');
    let $flatViewBtn = $('[data-flat-view-btn]');
    let $flatViewTab = $('[data-flat-view-tab]');
    $flatViewBtn.on("click", "li:not(._active)", function() {
        $(this)
            .addClass("_active")
            .siblings()
            .removeClass("_active")
            .closest($flatView)
            .find($flatViewTab)
            .removeClass("_active")
            .eq($(this).index())
            .addClass("_active");
    });
} );

let $popup      = $('[data-popup]');
let $popupClose = $('[data-popup-close]');
$popup.each(function() {
    let $wrapper = $(this);

    if (!Cookies.get('index-popup')) {
        $wrapper.removeClass('_hide');

        $popupClose.on('click', function() {
            $wrapper.addClass('_hide');
            //Устанавливаем куки
            Cookies.set('index-popup', '1', { expires : 1 });

        });

        return;
    }
});
